export default __webpack_public_path__ + "static/diamond-pattern-819de33ab89323625b77f98314b0bca2.webp";